<template>
  <div class="warp">
    <div class="top">
      <div class="title">
        <label class="sb">设备类型</label>
        <el-select v-model="equipments" placeholder="选择设备" class="sb">
          <el-option v-for="item in equipmentData" :key="item.id" :label="item.displayName" :value="item.id"></el-option>
        </el-select>
        <el-input style="width:250px;" v-model="searchText" placeholder="输入关键字"></el-input>
        <el-button style="margin-left:10px;" type="primary" class="primary" @click="query">查询</el-button>
      </div>
    </div>
    <div class="bottom">
      <nk-table id="table" height="100%" :data="tableData" :noDataTitle="'暂无数据'" :columns="columns"></nk-table>
    </div>
  </div>
</template>

<script>
import NkTable from "@/components/common/NkTable";
import * as utils from "@/utils/index.js";
import tree from "@/utils/tree.js";
export default {
  components: { NkTable },
  data () {
    return {
      tableData: [],
      equipments: null,
      equipmentData: [],
      columns: [],
      enumData: [],
      searchText: "",
    };
  },
  created () {
    let vm = this;
    vm.$api.enumClass.getSubEnumClasses2("", 0, "").then((res) => {
      vm.enumData = res.data;
      vm.getData();
    });
  },
  methods: {
    //获取数据
    async getData () {
      let vm = this;
      //获取枚举
      let resClass2 = await vm.$api.enumClass.getSubEnumClasses2(
        "DeviceType",
        1,
        this.$store.state.user.currentCompanyId
      );
      resClass2.data.splice(0, 1);
      console.log(resClass2.data[0]);
      vm.equipmentData = resClass2.data;
      vm.equipments = resClass2.data[0].id;
      vm.query();
    },
    //查询
    async query () {
      let vm = this;
      //根据枚举查询计量点
      let resClasses = await vm.$api.enumClass.getMeasuresFromEnumClasses(
        [vm.equipments],
        0
      );
      let resProperties2 = { data: null };
      if (resClasses.data[0].measures.length > 0) {
        let ids = [];
        for (let i = 0; i < resClasses.data[0].measures.length; i++) {
          const element = resClasses.data[0].measures[i];
          ids.push(element.id);
        }
        //查计量点参数信息
        resProperties2 = await vm.$api.measure.getMeasuresProperties2(
          JSON.stringify(ids)
        );
        let coulum = {};
        let tableData = [];
        for (let i = 0; i < resProperties2.data.length; i++) {
          const propertyGroups = resProperties2.data[i].propertyGroups;
          //每个计量点的参数对象
          let item = {
            measureName: resClasses.data[0].measures.find(
              (c) => c.id == resProperties2.data[i].id
            ).name,
          };
          // 拿到所有枚举数据
          // let nameData = await vm.$api.enumClass.getSubEnumClasses2(
          //   "",
          //   1,
          //   ""
          // );
          for (let j = 0; j < propertyGroups.length; j++) {
            if (propertyGroups[j].name.indexOf("BasicInformation") > -1) {
              for (let k = 0; k < propertyGroups[j].properties.length; k++) {
                let property = propertyGroups[j].properties[k];
                //判断生成colums格式
                if (!coulum.hasOwnProperty(property.name)) {
                  coulum[property.name] = property.displayName;
                }
                item[property.name] = property.value;

                if (property.regulation.valueType == 5) {
                  item[property.name] = this.enumData.find(
                    (c) => c.name == property.value
                  ).displayName;
                }
                //  item[property.name] = nameData.data[z].displayName;
                //匹配枚举的中文名
                // for (let z = 0; z < nameData.data.length; z++) {
                //   if (nameData.data[z].name == property.value) {
                //     console.log(1);
                //     item[property.name] = nameData.data[z].displayName;
                //   }
                // }
              }
            }
          }
          tableData.push(item);
        }
        let columns = [
          {
            prop: "measureName",
            label: "计量点名称",
          },
        ];
        for (let key in coulum) {
          columns.push({
            prop: key,
            label: coulum[key],
          });
        }
        vm.columns = columns;
        let searchData = [];
        if (vm.searchText.length == 0) {
          searchData = tableData
        } else {
          for (let i = 0; i < tableData.length; i++) {
            let suo = false;
            let obj = tableData[i];
            for (let key in obj) {
              if (obj[key].indexOf(vm.searchText) > -1) {
                suo = true;
                break;
              }
            }

            if (suo) {
              searchData.push(obj);
            }
          }
        }

        vm.tableData = searchData;
      } else {
        vm.columns = [];
        vm.tableData = [];
      }
    },
  },
};
</script>
<style scoped>
.warp {
  padding: 14px;
  box-sizing: border-box;
  display: flex;
  flex-flow: column;
  height: 100%;
}
.bottom {
  flex: 1;
  overflow: auto;
  margin-top: 14px;
}
.title {
  width: 100%;
  padding: 14px;
  border-bottom: 1px solid #ccc;
  box-sizing: border-box;
  display: flex;
  color: #000;
  align-items: center;
  background: #fff;
}
.sb {
  margin-right: 10px;
}

.primary >>> .el-button--primary {
  background-color: #0080ff;
  background: #0080ff;
  border-color: #0080ff;
}
::v-deep .el-button--primary {
  background-color: #0080ff;
  background: #0080ff;
  border-color: #0080ff;
}
</style>